export default "__VITE_ASSET__l5s6LlFM__"